// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.segmented-filter-item::part(item) {
  height: 35px;
}

.goalTypeFilter {
  display: flex;
}
.goalTypeFilter .goalTypeDropdown {
  width: 56%;
  margin-right: 12px;
}

.selected-strats-count-btn {
  display: flex;
  align-items: center;
}
.selected-strats-count-btn::part(overlay) {
  border-radius: 64px;
}
.selected-strats-count-btn::part(button) {
  color: #121619;
  border: 1px solid #A2A9B0;
  font-size: 14px;
  font-weight: 400;
  padding: 5px 10px 5px 12px;
  border-radius: 64px;
}
.selected-strats-count-btn::part(button):hover {
  background-color: #F4F5F7;
  border-color: #697077;
}

.bulkModalBody {
  -ms-overflow-style: none;
  overflow-x: hidden;
  overflow-y: scroll;
}
.bulkModalBody::-webkit-scrollbar {
  width: 4px !important;
}
.bulkModalBody::-webkit-scrollbar-track, .bulkModalBody::-webkit-scrollbar-thumb {
  background: transparent;
  width: 4px;
}
.bulkModalBody:hover, .bulkModalBody:active {
  -ms-overflow-style: auto;
  scrollbar-width: auto;
}
.bulkModalBody:hover::-webkit-scrollbar-thumb, .bulkModalBody:active::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.25);
}
.bulkModalBody:hover::-webkit-scrollbar, .bulkModalBody:active::-webkit-scrollbar {
  visibility: visible;
}

#bulk-delete-btn::part(button) {
  min-width: 147.95px;
  width: 147.95px;
}

.pacing-slider-label::part(typography) {
  color: var(--wpp-dataviz-color-seq-grey-600);
}

.prevent-editing-goal-msg::part(wrapper) {
  margin-top: 20px;
  padding: 12px 16px;
}
.prevent-editing-goal-msg::part(message-block) {
  gap: 8px;
}

.edit-confirmation-modal::part(content) {
  top: 230px;
  right: 160px;
  left: unset;
  transform: unset;
  animation: unset;
}

.amzn-settings-warning::part(message) {
  line-height: 20px;
  font-size: 13px;
}

.strategyInfoDspExternalLink:hover, .strategyInfoDspExternalLink:active,
.strategyInfoDspExternalLink a:hover {
  background-color: var(--wpp-grey-color-300) !important;
  color: var(--wpp-grey-1000) !important;
  text-decoration: none;
}

.dspFlightQuickLinkButton {
  position: relative !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: flex-start !important;
  padding-right: 24px !important;
}
.dspFlightQuickLinkButton a {
  color: var(--wpp-grey-1000) !important;
  text-decoration: none;
}
.dspFlightQuickLinkButton:hover {
  color: var(--wpp-grey-1000) !important;
}
.dspFlightQuickLinkButton .wpp-icon-external-link {
  --wpp-prop-icon-color: var(--wpp-grey-800) !important;
}

.dspClickableActionButton::part(inner) {
  font-weight: normal;
  color: var(--wpp-grey-1000) !important;
}

.strategyNameTooltip::part(tooltip-content) {
  box-sizing: border-box;
}
.strategyNameTooltip::part(text) {
  width: 100%;
}

.dspQuickLinkAccordion::part(content) {
  margin: 0;
}
.dspQuickLinkAccordion::part(icon) {
  color: var(--wpp-grey-800) !important;
}`, "",{"version":3,"sources":["webpack://./src/containers/StrategiesList/style.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;AACF;AACE;EACE,UAAA;EACA,kBAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,cAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AADJ;AAGI;EACE,yBAAA;EACA,qBAAA;AADN;;AAMA;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;AAHF;AAKE;EACE,qBAAA;AAHJ;AAME;EACE,uBAAA;EACA,UAAA;AAJJ;AAOE;EACE,wBAAA;EACA,qBAAA;AALJ;AAOI;EACE,+BAAA;AALN;AASE;EACE,mBAAA;AAPJ;;AAaE;EACE,mBAAA;EACA,eAAA;AAVJ;;AAcA;EACE,4CAAA;AAXF;;AAeE;EACE,gBAAA;EACA,kBAAA;AAZJ;AAcE;EACE,QAAA;AAZJ;;AAgBA;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,eAAA;AAbF;;AAiBE;;EAGE,sDAAA;EACA,sCAAA;EACA,qBAAA;AAfJ;;AAmBA;EACE,6BAAA;EACA,wBAAA;EACA,yCAAA;EACA,kCAAA;EACA,8BAAA;AAhBF;AAkBE;EACE,sCAAA;EACA,qBAAA;AAhBJ;AAkBE;EACE,sCAAA;AAhBJ;AAkBE;EACE,qDAAA;AAhBJ;;AAqBE;EACE,mBAAA;EACA,sCAAA;AAlBJ;;AAyBE;EACE,sBAAA;AAtBJ;AAwBE;EACE,WAAA;AAtBJ;;AA2BE;EACE,SAAA;AAxBJ;AA2BE;EACE,qCAAA;AAzBJ","sourcesContent":[".segmented-filter-item::part(item) {\n  height: 35px;\n}\n\n.goalTypeFilter {\n  display: flex;\n\n  & .goalTypeDropdown {\n    width: 56%;\n    margin-right: 12px;\n  }\n}\n\n.selected-strats-count-btn {\n  display: flex;\n  align-items: center;\n\n  &::part(overlay) {\n    border-radius: 64px;\n  }\n\n  &::part(button) {\n    color: #121619;\n    border: 1px solid #A2A9B0;\n    font-size: 14px;\n    font-weight: 400;\n    padding: 5px 10px 5px 12px;\n    border-radius: 64px;\n\n    &:hover {\n      background-color: #F4F5F7;\n      border-color: #697077;\n    }\n  }\n}\n\n.bulkModalBody {\n  -ms-overflow-style: none;\n  overflow-x: hidden;\n  overflow-y: scroll;\n\n  &::-webkit-scrollbar {\n    width: 4px !important;\n  }\n\n  &::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb {\n    background: transparent;\n    width: 4px;\n  }\n\n  &:hover, &:active {\n    -ms-overflow-style: auto;\n    scrollbar-width: auto;\n\n    &::-webkit-scrollbar-thumb {\n      background: rgba(0,0,0,.25);\n    }\n  }\n\n  &:hover::-webkit-scrollbar, &:active::-webkit-scrollbar {\n    visibility: visible;\n  }\n  \n}\n\n#bulk-delete-btn {\n  &::part(button) {\n    min-width: 147.95px;\n    width: 147.95px;\n  }\n}\n\n.pacing-slider-label::part(typography) {\n  color: var(--wpp-dataviz-color-seq-grey-600);\n}\n\n.prevent-editing-goal-msg{\n  &::part(wrapper) {\n    margin-top: 20px;\n    padding: 12px 16px;\n  }\n  &::part(message-block) {\n    gap: 8px;\n  }\n}\n\n.edit-confirmation-modal::part(content) {\n  top: 230px;\n  right: 160px;\n  left: unset;\n  transform: unset;\n  animation: unset;\n}\n\n.amzn-settings-warning::part(message) {\n  line-height: 20px;\n  font-size: 13px;\n}\n\n.strategyInfoDspExternalLink {\n  &:hover,\n  &:active,\n  a:hover {\n    background-color: var(--wpp-grey-color-300) !important;\n    color: var(--wpp-grey-1000) !important;\n    text-decoration: none;\n  }\n}\n\n.dspFlightQuickLinkButton {\n  position: relative !important;\n  display: flex !important; \n  justify-content: space-between !important;\n  align-items: flex-start !important;\n  padding-right: 24px !important;\n  \n  a {\n    color: var(--wpp-grey-1000) !important;\n    text-decoration: none;\n  }\n  &:hover {\n    color: var(--wpp-grey-1000) !important;\n  }\n  .wpp-icon-external-link {\n    --wpp-prop-icon-color: var(--wpp-grey-800) !important;\n  }\n}\n\n.dspClickableActionButton {\n  &::part(inner) {\n    font-weight: normal;\n    color: var(--wpp-grey-1000) !important;\n  }\n}\n\n// below is to fix the tooltip overflow issue in home page with strat names\n// below rules will override the default inner tooltip styles\n.strategyNameTooltip { \n  &::part(tooltip-content) {\n    box-sizing: border-box;\n  }\n  &::part(text) {\n    width: 100%\n  }\n}\n\n.dspQuickLinkAccordion {\n  &::part(content) {\n    margin: 0;\n  }\n\n  &::part(icon) {\n    color: var(--wpp-grey-800) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
